import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import DeliverySidebar from "../Layouts/DeliverySidebar";
import axios from "axios";
import $ from "jquery";

export class ImmediateAssistanceOfTheNewborn extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      name: "",
      date: "",
      hour: "",
      alive: "",
      sex: "",
      apgar: "",
      weight: "",
      term: "",
      stillbirthstatus: "",
      stillbirthreason: "",
      deadOneHourstatus: "",
      deadOneHourreason: "",
      loading: false

      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }
  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  componentDidMount() {
    $(".deadonehouryes").click(function () {
      $(".deadonereason").show();
    });
    $(".deadonehourno").click(function () {
      $(".deadonereason").hide();
    });

    $(".stillbirthyes").click(function () {
      $(".stillbirthtype").show();
    });
    $(".stillbirthno").click(function () {
      $(".stillbirthtype").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(this.state);
    this.setState({
      loading: true
    })
    axios
      .post(
        this.api_url+"delivery/assistancenewborn",
        this.state,
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log(response);
        this.setState({
          loading: false
        })
        if (response.data["status"]) {
          $(".alert-success").show();
        }

        setTimeout(function () {
          window.location.href = "/delivery/apgar/score";
        }, 500);

        //
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      name,
      date,
      hour,
      alive,
      sex,
      apgar,
      weight,
      term,
      stillbirthstatus,
      stillbirthreason,
      deadOneHourstatus,
      deadOneHourreason,
      loading
    } = this.state;
    return (
      <div>
        <Headers />
        <DeliverySidebar />

        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2"></div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Immediate Assistance Of The Newborn
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Name
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={name}
                      name="name"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Date
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={date}
                      name="date"
                      type="date"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Hour
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={hour}
                      name="hour"
                      type="text"
                      required
                    />
                  </div>
                  {/* <div className="py-1">
                         <h6 className="text-capitalize" style={ fontFamilyNunito }>Gestational Age</h6><input onChange={this.handleChange} value={alive} name="GestationalAge" className="form-control" type="text" required/>
                     </div> */}
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Sex
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={sex}
                      name="sex"
                      required
                    >
                      <optgroup label="Sex">
                        <option selected disabled></option>
                        <option value="female">Female</option>
                        <option value="male">Male</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Weight
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={weight}
                      name="weight"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Apgar
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={apgar}
                      name="apgar"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Term
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={term}
                      name="term"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Still Birth Status
                    </h6>

                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={stillbirthstatus}
                      name="stillbirthstatus"
                      type="text"
                      required
                    >
                      <optgroup label="Still Birth Status">
                        <option selected disabled></option>
                        <option value="yes" className="stillbirthyes">
                          Yes
                        </option>
                        <option value="no" className="stillbirthno">
                          No
                        </option>
                      </optgroup>
                    </select>
                  </div>

                  <div className="py-1 stillbirthtype" style={displayHidden}>
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Select Type
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={stillbirthstatus}
                      name="stillbirthstatus"
                      type="text"
                    >
                      <optgroup label="Still Birth Type">
                        <option selected disabled></option>
                        <option value="fresh">Fresh</option>
                        <option value="macerated">Macerated</option>
                      </optgroup>
                    </select>
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Dead One Hour Status
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={deadOneHourstatus}
                      name="deadOneHourstatus"
                      type="text"
                      required
                    >
                      <optgroup label="Dead One Hour Status">
                        <option selected disabled></option>
                        <option value="yes" className="deadonehouryes">
                          Yes
                        </option>
                        <option value="no" className="deadonehourno">
                          No
                        </option>
                      </optgroup>
                    </select>
                  </div>
                  <div className="py-1 deadonereason" style={displayHidden}>
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Dead One Hour Reason
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={deadOneHourreason}
                      name="deadOneHourreason"
                      type="text"
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Still Birth Reason
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={stillbirthreason}
                      name="stillbirthreason"
                      type="text"
                      
                    ></textarea>
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' : 'Submit'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default ImmediateAssistanceOfTheNewborn;
